export default __webpack_public_path__ + "static/sac.cover-d5b12aa68c82329cf25d7cfc3bcad9a7.jpg";